<template>
<v-text-field  :id="id"  v-model="displayValue" :disabled="Boolean(aktif)" :label="etiket" :name="name" @blur="isInputActive=false" :autocomplete="autocomplete"  @focus="isInputActive=true" >
</v-text-field>


</template>

<script>
export default {
  name: 'currency-input',
  data () {
    return {
      isInputActive: false
    }
  },
  props: ['value', 'tabindex', 'name', 'id', 'autocomplete', 'etiket','aktif','simge'],
  computed: {
 displayValue: {
      get: function () {
        if (this.isInputActive && this.value!=null) {
 
          return this.value.toFixed(2)
        } else {
          // If the value is not a number, default to 0.00
          if (isNaN(this.value) || this.value === null) {
            return "0.00" + this.simge;
          }

          // This formats the number to include commas for thousands and a currency symbol
          return this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,') + this.simge

        }
      },
      set: function (modifiedValue) {
        let newValue = parseFloat(modifiedValue)
        if (isNaN(newValue)) {
          newValue = 0
        }
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style scoped>
</style>



